import { render, staticRenderFns } from "./HomeContentExhibitionList.vue?vue&type=template&id=5d56f30a&scoped=true&"
import script from "./HomeContentExhibitionList.vue?vue&type=script&lang=js&"
export * from "./HomeContentExhibitionList.vue?vue&type=script&lang=js&"
import style0 from "./HomeContentExhibitionList.vue?vue&type=style&index=0&id=5d56f30a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d56f30a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VDataTable,VIcon})
